function cbSearch(sender) {
    const $ = jQuery.noConflict();
    const val = $(sender).val().toLowerCase();
    const wrapper = $(sender).parents('.row:first').next();
    wrapper.children().each(function() {
        const text = $(this).text().toLowerCase();
        $(this).toggle(text.split(val).length > 1);
    });
}